import type { Logger } from 'tslog';

import React, { createContext, useContext, useMemo } from 'react';

import { getLogger } from '../utils/logger';

interface LoggerContextType {
  debug?: boolean;
  logger: Logger<unknown>;
}

const LoggerContext = createContext<LoggerContextType | undefined>(undefined);

interface LoggerProviderProps {
  debug?: boolean;
  children: React.ReactNode;
}
export function LoggerProvider({ debug, children }: LoggerProviderProps) {
  const logger = useMemo(() => getLogger(debug), [debug]);

  return <LoggerContext.Provider value={{ debug, logger }}>{children}</LoggerContext.Provider>;
}

export const useLogger = (): LoggerContextType => {
  const context = useContext(LoggerContext);

  if (context === undefined) {
    throw new Error('useLogger must be used within a LoggerProvider');
  }

  return context;
};
